import { DateTime, DateTimeOptions } from "luxon";
import { CountryCodes } from "./constants";

export type DateType = string | number | Date | DateTime;

export const transformToDate = (date?: DateType | string | null | undefined, zone?: DateTimeOptions["zone"]) => {
  let tzName = zone;
  if (zone === "" || zone === null || zone === undefined) {
    tzName = undefined;
  }
  if (typeof date === "string") {
    const isoDate = DateTime.fromISO(date, { zone: tzName });
    return isoDate.isValid ? isoDate : null;
  }
  if (typeof date === "number") {
    const msDate = DateTime.fromMillis(date, { zone: tzName });
    return msDate.isValid ? msDate : null;
  }
  if (date instanceof Date) {
    const jsDate = DateTime.fromJSDate(date, { zone: tzName });
    return jsDate;
  }
  if (date instanceof DateTime && date.isValid) {
    return date;
  }
  return null;
};

export const getInternationalDateFormat = (countryCode: string | undefined) => {
  switch (countryCode?.toLowerCase()) {
    case CountryCodes.US:
      return {
        shortDateFormat: "MM/dd/yyyy",
        longDateFormat: "HH:mm LL-dd-y",
        locale: "en-US",
        fullDateFormat: "LL-dd-y HH:mm z",
      };
    case CountryCodes.UK:
      return {
        shortDateFormat: "dd/MM/yyyy",
        longDateFormat: "HH:mm dd-LL-y",
        locale: "en-GB",
        fullDateFormat: "dd-LL-y HH:mm z",
      };
    default:
      return {
        shortDateFormat: "MM/dd/yyyy",
        longDateFormat: "HH:mm LL-dd-y",
        locale: "en-US",
        fullDateFormat: "LL-dd-y HH:mm z",
      };
  }
};
